import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import { ResumePopupContext } from "../../../Context/resumePopupContext";
import {
  inbetweenSectionPaddings,
  availableSection,
} from "../../../TemplateConfig";
import SVGRenderer from "./SVGRenderer";
import "./sectionHeader.css";

const SectionIcon = ({ incomingSectionId }) => {
  // Find the section that matches the incomingSectionId
  const sectionData = availableSection.find(
    (section) => section.sectionId === incomingSectionId
  );

  // If a matching section is found, use its font_class, otherwise default to a generic class
  const fontClass = sectionData?.font_class || "fa fa-certificate";

  return (
    <i
      className={`${fontClass} mr-2`} // Replace the class with the matching font_class
      aria-hidden="true"
    ></i>
  );
};

function SectionHeader({
  styles,
  settings,
  resumeFields,
  sectionId,
  resumeTitleHandler,
  resumeUpdate,
  PageMargin,
  SectionMargin,
}) {
  const {
    selectedFont,
    primaryColor,
    secondaryColor,
    titleFont,
    bodyFont,
    titleBgColor,
  } = styles;
  const [t, i18n] = useTranslation("common");

  const analyzerData = useSelector((state) => state.analyzeResume.data);
  const { preview, setPreview } = useContext(ResumePopupContext);

  return (
    <>
      <div>
        <div
          id={`${sectionId}-title `}
          className="title-section"
          style={{
            backgroundColor: settings?.isTitleBackgroundColor
              ? titleBgColor
              : "unset",
          }}
        >
          {settings && settings.showIcon && (
            <>
              <SVGRenderer
                iconName={sectionId}
                primaryColor={styles.iconPrimaryColor}
                secondaryColor={styles.iconSecondaryColor}
                originalSecondaryColor={styles.secondaryColor}
                size={selectedFont?.h2}
                sectionId={sectionId}
              />
            </>
          )}

          <ContentEditable
            sectionId={sectionId}
            name="customTitle"
            index="0"
            tagType="div"
            className={`section-title ${sectionId}-title`}
            value={
              resumeFields.customTitle
                ? t(`customTitle`, {
                    customTitle: resumeFields.customTitle,
                  })
                : sectionId.includes("customDate")
                ? "Custom Date"
                : sectionId.includes("customText")
                ? "Custom Text"
                : t(`${sectionId}.defaultTitle`)
            }
            style={{
              color: primaryColor,
              fontFamily: titleFont,
              fontSize: selectedFont?.h2,
              fontWeight: 500,
              lineHeight: selectedFont?.h2_lineHeight,
              fontStyle: "normal",
            }}
            placeholder="Title"
            onChange={resumeTitleHandler}
            onBlur={resumeUpdate}
            // onClick={(e) => props.sectionClick(e, "title")}
          />
        </div>
        {settings && settings.sectionHeaderUnderline && (
          <hr
            className="section_header_underline"
            style={{
              background: secondaryColor,
              margin:
                settings && settings.underlineWidth == "small"
                  ? `${inbetweenSectionPaddings[SectionMargin - 1]}px 0`
                  : SectionMargin
                  ? `${inbetweenSectionPaddings[SectionMargin - 1]}px auto`
                  : `${inbetweenSectionPaddings[0]}px auto`,
              width:
                settings && settings.underlineWidth == "small"
                  ? "40px"
                  : "100%",
            }}
          />
        )}
      </div>
    </>
  );
}

export default SectionHeader;
